import { useContext } from 'react';
import { DatePickerContext } from '../date-picker-provider';
import { DatePickerUtils, DatePickerContextValue } from '../types';

export function useDatePickerUtils(): DatePickerUtils {
	const { utils } = useContext<DatePickerContextValue>(DatePickerContext);

	return utils as DatePickerUtils;
}
